module.exports = __webpack_public_path__ + "img/vladiyan2.f99851bc.png";